/**
 * Shared status badge / label maps for architecture-import rows.
 *
 * Kept in one place so the workspace hub and the per-project send page
 * stay visually consistent and so the back-compat list (legacy Codie
 * wire values still in the DB for rows submitted before the status
 * rename) only has to be maintained once.
 */

export const IMPORT_STATUS_BADGE: Record<string, string> = {
  generated: 'badge-ghost',
  sent_to_codie: 'badge-info',
  imported: 'badge-success',
  rejected: 'badge-warning',
  // Backward-compat with legacy Codie wire values still in the DB
  // for rows submitted before the status-rename migration.
  analyzed: 'badge-info',
  archived: 'badge-warning',
};

export const IMPORT_STATUS_LABEL: Record<string, string> = {
  generated: 'Generated',
  sent_to_codie: 'Sent to Codie',
  imported: 'Imported',
  rejected: 'Rejected',
  analyzed: 'Sent to Codie',
  archived: 'Rejected',
};

export const NON_TERMINAL_IMPORT_STATUSES: ReadonlySet<string> = new Set([
  'generated',
  'sent_to_codie',
  'analyzed',
]);

export const DEFAULT_IMPORT_STATUS_BADGE = 'badge-ghost';

/** Lookup helper with a safe fallback to the raw value. */
export function importStatusLabel(status: string): string {
  return IMPORT_STATUS_LABEL[status] ?? status;
}

/** Lookup helper with a safe ``badge-ghost`` fallback. */
export function importStatusBadge(status: string): string {
  return IMPORT_STATUS_BADGE[status] ?? DEFAULT_IMPORT_STATUS_BADGE;
}
